module.exports = __webpack_public_path__ + "34b2d6231ea1f6883a15b9248d98f607.MP3";